import { MergeStateTypeId as MergeStateTypeId$1, BothRunning as BothRunning$1, LeftDone as LeftDone$1, RightDone as RightDone$1, isMergeState as isMergeState$1, isBothRunning as isBothRunning$1, isLeftDone as isLeftDone$1, isRightDone as isRightDone$1, match as match$1 } from '../../internal/channel/mergeState.esm.js';

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbols
 */
const MergeStateTypeId = MergeStateTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
const BothRunning = BothRunning$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const LeftDone = LeftDone$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const RightDone = RightDone$1;

/**
 * Returns `true` if the specified value is a `MergeState`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isMergeState = isMergeState$1;

/**
 * Returns `true` if the specified `MergeState` is a `BothRunning`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isBothRunning = isBothRunning$1;

/**
 * Returns `true` if the specified `MergeState` is a `LeftDone`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isLeftDone = isLeftDone$1;

/**
 * Returns `true` if the specified `MergeState` is a `RightDone`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isRightDone = isRightDone$1;

/**
 * @since 2.0.0
 * @category folding
 */
const match = match$1;

export { BothRunning, LeftDone, MergeStateTypeId, RightDone, isBothRunning, isLeftDone, isMergeState, isRightDone, match };
